export enum ClientSitesComponentContextEnum {
	DEFAULT = '',
	INTERNAL = 'internal',
	CLIENT = 'client'
}
